import React from "react";
import { ArrowRight } from "lucide-react";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxlbmdpbmVlcnMlMjBpbmR1c3RyaWFsJTIwcGxhbnR8ZW58MHx8fHwxNzgzMjk3MzI4fDA&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-white py-24 sm:py-28"
    >
      <div className="kip-container grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 reveal">
          <span className="kip-overline">À Propos</span>
          <span className="kip-accent-bar mt-4" />
          <h2
            data-testid="about-title"
            className="font-display font-black text-[#1A2744] text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]"
          >
            Votre partenaire énergie{" "}
            <span className="text-[#E85D26]">en Côte d'Ivoire.</span>
          </h2>

          <div className="mt-8 space-y-5 text-[#334155] text-base sm:text-lg leading-relaxed max-w-2xl">
            <p>
              Filiale d'<b>EKIP Holding Company</b>, <b>KIP Energy</b> est le distributeur
              exclusif des solutions Wayne (Dover Fueling Solutions) sur le
              territoire ivoirien. Notre mission : moderniser l'infrastructure
              énergétique nationale et offrir une expérience carburant à la
              hauteur des standards internationaux.
            </p>
            <p>
              Nous développons un écosystème pétrolier intégré — de la
              distribution d'équipements haute performance à la construction de
              stations nouvelle génération, en passant par le stockage et le
              trading de produits pétroliers.
            </p>
            <p>
              Notre ambition à horizon 2030 : bâtir <b>100 stations Wayne</b> à
              travers la Côte d'Ivoire, propulser la mobilité et accompagner la
              croissance économique du pays.
            </p>
          </div>

          <div className="mt-10 flex flex-wrap gap-6">
            <div className="border-l-2 border-[#E85D26] pl-4">
              <div className="font-display text-2xl font-bold text-[#1A2744]">
                Vision
              </div>
              <div className="text-sm text-[#64748B] mt-1">
                Premier écosystème énergétique d'Afrique de l'Ouest
              </div>
            </div>
            <div className="border-l-2 border-[#E85D26] pl-4">
              <div className="font-display text-2xl font-bold text-[#1A2744]">
                Mission
              </div>
              <div className="text-sm text-[#64748B] mt-1">
                Moderniser la distribution de carburant en Côte d'Ivoire
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-5 reveal">
          <div className="relative">
            <div
              aria-hidden
              className="absolute -inset-4 border-2 border-[#E85D26] translate-x-4 translate-y-4"
            />
            <img
              src={ABOUT_IMG}
              alt="Équipe industrielle KIP Energy"
              loading="lazy"
              data-testid="about-image"
              className="relative w-full h-[480px] object-cover"
            />
            <div className="absolute bottom-4 left-4 right-4 bg-[#1A2744] text-white p-5">
              <div className="text-xs tracking-[0.2em] text-[#E85D26] uppercase mb-1">
                EKIP Holding
              </div>
              <div className="font-display font-bold text-lg leading-tight">
                Ensemble, Vivons Mieux
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
